<div
  class="outer"
  (click)="pick()"
  [ngClass]="{
    pickable: pickable,
    picked: picked,
  }">
  <ng-container
    *ngFor="
      let mode of small && !nopreview ? ['actual', 'preview'] : ['actual']
    ">
    <div
      class="idea-wrapper chrome-no-repaint"
      #wrapper
      [ngClass]="{
        unpublished: !idea.published,
        small: small && mode !== 'preview',
        xs: xs,
        preview: mode === 'preview',
      }">
      <div (click)="ideaClick()" class="idea chrome-no-repaint">
        <div
          class="idea-image-div"
          [ngStyle]="{
            'background-image': 'url(' + thumbnailImage + ')',
          }"></div>
        <div
          class="topic-ribbon"
          *ngIf="showTopic && !showPrev"
          routerLink="/topics/{{ session._id }}">
          <a routerLink="/topics/{{ session._id }}">
            {{ session.config.title }}
          </a>
        </div>
        <div
          class="ribbon"
          *ngIf="
            (idea.moves && idea.moves.length > 0) ||
            session.me._id === idea.created_by ||
            (session.me._id !== idea.created_by && isCollaborator)
          ">
          <div
            class="move-notice"
            [ngClass]="{
              active: session.me._id === idea.created_by || isCollaborator,
            }"
            *ngIf="idea.moves && idea.moves.length > 0">
            <span>Moved</span>
          </div>
          <div *ngIf="session.me._id === idea.created_by">
            <span>Own project {{ idea.published ? '' : '(unpublished)' }}</span>
          </div>
          <div *ngIf="session.me._id !== idea.created_by && isCollaborator">
            <span>You are a collaborator</span>
          </div>
        </div>
        <div class="pick-overlay" *ngIf="pickable || picked">
          <div class="pin">
            <img alt src="assets/icons/picked.svg" />
          </div>
        </div>
      </div>
      <div class="idea-description chrome-no-repaint">
        <div class="idea-text">
          <p class="text-secondary mb-0">
            <small>Created on {{ idea.created_at | date: 'YYYY/MM/dd' }}</small>
          </p>
          <h3 (click)="ideaClick()">
            {{ title }}
          </h3>
          <p *ngIf="idea.categories?.length" class="text-secondary mb-0">
            <small>{{ idea.categories.join(', ') }}</small>
          </p>

          <!-- <p class="oneliner" [ngClass]="{ 'no-one-liner': !idea.one_liner }">
            {{ oneliner }}
          </p> -->
        </div>

        <div class="idea-footer chrome-no-repaint">
          <!--
          <p class="contributors"><img src="assets/images/userpic.png" width="30" height="30" alt="Contributors"> 1</p>
          -->

          <div class="tags chrome-no-repaint">
            <div class="tags-wrapper">
              <div class="tag" *ngFor="let tag of idea.tags">{{ tag }}</div>
              <div class="spacer-tag tag"></div>
            </div>
            <div class="cutoff"></div>
          </div>

          <p class="followers">
            <span
              (click)="iFollow ? unfollow($event) : follow($event)"
              [ngClass]="iFollow ? 'icon-star-full' : 'icon-star-empty'"></span>
            {{ idea.followers.length }}
          </p>
          <!--
          <i class="idea-maturity fa fa-2x fa-leaf" title="Normal Idea" *ngIf="idea.mature"></i>
          <i class="idea-maturity fa fa-2x fa-magic" title="Idea Spark" *ngIf="!idea.mature"></i>
          -->
        </div>
      </div>
    </div>
  </ng-container>
</div>
